import moment from 'moment-timezone';

import { TimeFrameLabels } from './time-frame-labels.enum';

export const ChartThumbnailDataSettings = {
  currentWeek: {
    xAxisLabel: TimeFrameLabels.CurrentWeek,
  },
  lastWeek: {
    xAxisLabel: TimeFrameLabels.LastWeek,
  },
  currentMonth: {
    xAxisLabel: moment().format('MMMM YYYY'),
  },
  lastMonth: {
    xAxisLabel: moment().subtract(1, 'month').format('MMMM YYYY'),
  },
  currentQuarter: {
    xAxisLabel: `${moment().startOf('quarter').format('MMMM YYYY')}  - ${moment()
      .endOf('quarter')
      .format('MMMM YYYY')}`,
  },
  lastQuarter: {
    xAxisLabel: `${moment().subtract(1, 'quarter').startOf('quarter').format('MMMM YYYY')}  - ${moment()
      .subtract(1, 'quarter')
      .endOf('quarter')
      .format('MMMM YYYY')}`,
  },
  currentYear: {
    xAxisLabel: moment().format('YYYY'),
  },
  lastYear: {
    xAxisLabel: moment().subtract(1, 'year').format('YYYY'),
  },
  all: {
    xAxisLabel: TimeFrameLabels.AllTime,
  },
};
